import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '@alexpireddu/map-ui';
import { FC } from 'react';

export interface StopCampaignModalProps {
  onClose: () => void;
  onConfirm: () => void;
}

const StopCampaignModal: FC<StopCampaignModalProps> = ({
  onClose,
  onConfirm,
}) => (
  <Modal size="md">
    <ModalHeader>Interrompi campagna</ModalHeader>
    <ModalBody>
      <span>Sei sicuro di voler interrompere la campagna?</span>
    </ModalBody>
    <ModalFooter>
      <Button variant="secondary" ml="8px" onClick={onClose}>
        Annulla
      </Button>
      <Button variant="primary" mr="8px" onClick={onConfirm}>
        Conferma
      </Button>
    </ModalFooter>
  </Modal>
);

export default StopCampaignModal;
